/**
 * Asynchronously loads the component for Upskilling
 */

import { lazyLoad } from "utils/loadable";

export const MES = lazyLoad(
  () => import("./index"),
  (module) => module.MES
);
